import { render, staticRenderFns } from "./SelectShops.vue?vue&type=template&id=5786aad6&"
import script from "./SelectShops.vue?vue&type=script&lang=js&"
export * from "./SelectShops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports